import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PopoverController } from '@ionic/angular';
import { NavController } from '@ionic/angular';

export interface Ioption{
  title:string;
  pageName:string;

};

@Component({
  selector: 'app-opcion-profile',
  templateUrl: './opcion-profile.component.html',
  styleUrls: ['./opcion-profile.component.scss'],
})
export class OpcionProfileComponent implements OnInit {

	pages:Ioption[]=[
		{title: this.translate.store.translations[this.translate.store.currentLang]["CHANGE PASSWORD"] ,pageName:'change-password'},
    {title: this.translate.store.translations[this.translate.store.currentLang]["VERIFY ACCOUNT"],pageName:'verific-account-user'},
    //{title:this.translate.store.translations[this.translate.store.currentLang]["RATING DETAILS"],pageName:'RatingDetailPage'},

  ];

  constructor(
  	public translate: TranslateService,
  	public pop: PopoverController,
    private navCtrl: NavController,
  	) { 
  }

  ngOnInit() {}

  Opcion_change(page:Ioption){
    this.navCtrl.navigateForward('/'+page.pageName);

    this.pop.dismiss();
  }
}
